module.exports = __webpack_public_path__ + "static/media/profile_photo.883d4c9c.svg";